import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-campaigns',
  templateUrl: './edit-campaigns.component.html',
  styleUrls: ['./edit-campaigns.component.css']
})
export class EditCampaignsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
